import HttpService from '@/common/services/HttpService'
import type { BreakDTOV1 } from '@/agent/types/break'

export const getBreaks = () => {
  return HttpService.getData<BreakDTOV1[]>('/api/v1/breaks')
}
